import {ReactPortal, useEffect, useRef} from 'react'

import {createPortal} from 'react-dom'
import {useIsClientSide} from './hooks/useIsClientSide'

export const portalContainerId = 'portalContainerId'

export const Portal = ({children}: Pick<ReactPortal, 'children'>) => {
  const ref = useRef<HTMLElement | null>(null)
  const isClient = useIsClientSide()

  useEffect(() => {
    ref.current = document.querySelector(`#${portalContainerId}`)
  }, [])

  return isClient && ref.current ? createPortal(children, ref.current) : null
}
